export default __webpack_public_path__ + "static/media/logoGold2021.84ca1108.png";